
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

export const AccessDenied = () => {
  return (
    <Card className="border-destructive">
      <CardHeader>
        <CardTitle className="flex items-center text-destructive">
          <AlertTriangle className="h-6 w-6 mr-2" />
          Access Restricted
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">
          Only super admins can access the PEO verification system. 
          Please contact an administrator if you need access.
        </p>
      </CardContent>
    </Card>
  );
};
